module.exports = __webpack_public_path__ + "img/agave_3.9791c20d.jpeg";